import { useState, useEffect } from 'react';
import FingerprintJS from '@fingerprintjs/fingerprintjs'

// Initialize an agent at application startup.
const fpPromise = FingerprintJS.load()

export function useFingerPrint() {
  const [status, setStatus] = useState('idle');
  const [data, setData] = useState({})

  const getFingerPrint = async () => {
    setStatus('loading');

    const fp = await fpPromise;
    const result = await fp.get();

    setStatus('success');
    setData(result);
  }

  useEffect(() => {
    getFingerPrint()
  }, [])

  return { fingerprint: data, isLoading: status === 'loading', isSuccess: status === 'success', status }
}
